import { Stack, Typography } from "@mui/material"
import { CostFigure } from "./cost-figure"

export function CostLine({ label, value, currencySymbol, bold }) {
    const labelWeight = getLabelWeight()

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" color="text.primary" sx={{ fontSize: "16px" }} fontWeight={labelWeight}>
                {label}
            </Typography>
            <CostFigure value={value} currencySymbol={currencySymbol} sx={{ fontSize: "16px" }} fontWeight={700} />
        </Stack>
    )

    function getLabelWeight() {
        if (bold) return 600
        return 400
    }
}
